import React, { useState } from 'react';
import { useObservable } from 'react-use-observable';

import { Alert, Button, Typography } from 'antd';

import { CHARGEBACK_HELP_URL } from 'helpers/constants';
import { EAnticipationStatus } from 'v2/interfaces/user';
import eduzzAccountsService from 'v2/services/eduzzAccount';

const ChargebackAlert = () => {
  const [visible, setVisible] = useState(true);
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  const handleClose = () => {
    setVisible(false);
  };

  if (!visible) return null;
  if (!user || user?.anticipation_status === EAnticipationStatus.LIBERADO) return null;

  return (
    <>
      <Alert
        type={user?.anticipation_status === EAnticipationStatus.BLOQUEADO ? 'error' : 'warning'}
        showIcon
        action={
          <Button onClick={handleClose} aria-label='fechar'>
            Entendi
          </Button>
        }
        className='max-sm:flex-col max-sm:items-center max-sm:text-center'
        message={<Typography.Text strong>Atenção</Typography.Text>}
        description={
          <span>
            {user?.anticipation_status_message}{' '}
            <Typography.Link href={CHARGEBACK_HELP_URL} target='_blank' rel='noopener noreferrer'>
              O que é chargeback?
            </Typography.Link>
          </span>
        }
      />
    </>
  );
};

export default ChargebackAlert;
